import { TileLayer, type Map as LeafletMap } from 'leaflet';

const BASEMAP_TILE_CLASS = 'fm-basemap-tiles';

/**
 * The deepest zoom an automatic fit may reach on this map: the shallowest
 * native level among its mounted basemap grids (`FmMmlBasemapTiles` tags them),
 * so a tiny stand never fits into resampled or missing tiles. Data overlays
 * (radar, dated rasters) do not cap the fit. `undefined` when no tagged
 * basemap is mounted, leaving the caller's own cap in force.
 */
export function basemapFitMaxZoom(map: LeafletMap): number | undefined {
  let cap: number | undefined;
  map.eachLayer((layer) => {
    if (!(layer instanceof TileLayer)) return;
    const { className, maxNativeZoom } = layer.options;
    if (!className?.split(/\s+/).includes(BASEMAP_TILE_CLASS)) return;
    if (typeof maxNativeZoom !== 'number') return;
    cap = cap === undefined ? maxNativeZoom : Math.min(cap, maxNativeZoom);
  });
  return cap;
}

/** `requested` clamped to the map's basemap coverage. */
export function clampFitZoom(map: LeafletMap, requested?: number): number | undefined {
  const cap = basemapFitMaxZoom(map);
  if (cap === undefined) return requested;
  return requested === undefined ? cap : Math.min(requested, cap);
}
